<template>
    <div>
            <el-tabs v-model="activeTab">
                <el-tab-pane name="tab_1">
                    <span slot="label" @click="changetab(1)"><i class="el-icon-view"></i> 项目阶段 </span>
                    <el-row  :gutter="40">
                          <el-col :span="spanLeft">
                   <sy-baselist
                        ref="jobPhoto"
                        :pageSize="100"
                        :autoSearch="false"
                        title="阶段信息"
                        @beforeAdd="beforeAddDetail"
                        @current-change="currentChange"
                        editVue="business/ProjectDetail_Edit.vue"
                        listUrl="server/business/Project.ashx?cmd=GetDetailList"
                        deleteUrl="server/business/Project.ashx?cmd=DeleteDetail"
                >
                    <el-table-column prop="FName" label="阶段" width="200" >
                         <template slot-scope="scope">
                          <span v-if="scope.row.FIsTask==1">{{ scope.row.FName }}</span>
                          <span v-else style="color:blue;">{{ scope.row.FName }}</span>
                        </template>
                    </el-table-column>
                      <el-table-column prop="LeaderName" label="负责人" width="100">
                    </el-table-column>
                    <el-table-column prop="FStartTime" label="开始时间" :formatter="formatDate2" width="180" sortable>
                    </el-table-column>
                    <el-table-column prop="FEndTime" label="结束时间" :formatter="formatDate2" width="180" sortable >
                    </el-table-column>
                      <el-table-column prop="FProgress" label="进度" width="80">
                    </el-table-column>
                     <template scope="props" slot="extendbtn">
                       <el-button size="mini" v-if="showbtn(props.row)" class="el-icon-plus el-button el-button--text el-button--mini"  @click="addchild(props.row)">添加子级</el-button>
                   </template>
                </sy-baselist>
                <editform ref="editforms"></editform>
                          </el-col>
                <el-col :span="24-spanLeft">
                <Duty1  @onPackUp="onPackUp" :stageview="true" ref="emp"></Duty1>
               </el-col>
                     </el-row>
              
                </el-tab-pane>
                <el-tab-pane name="tab_2">
                    <span slot="label" @click="changetab(2)"><i class="el-icon-date"></i> 项目任务</span>
                    <Duty  ref="duty" ></Duty>
                </el-tab-pane>
                <el-tab-pane   name="tab_3">
                    <span slot="label" @click="changetab(3)"><i class="el-icon-document"></i> 项目汇报</span>
                     <sy-baselist
                        ref="proreports"
                        :autoSearch="false"
                        title="任务汇报"
                        hideAdd
                        hideOperate
                        :filters="reportfilters"
                        listUrl="server/business/Duty.ashx?cmd=GetReportList"    
                >
                    <el-table-column prop="ProjectName" label="所属项目名称" width="250" >
                    </el-table-column>
                    <el-table-column prop="ProjectDetailName" label="项目阶段" width="250" >
                    </el-table-column>
                     <el-table-column prop="DutyName" label="任务名称" width="250" >
                    </el-table-column>
                    <el-table-column prop="UserName" label="汇报人"  width="100">
                    </el-table-column>
                    <el-table-column prop="FCreateTime" label="汇报时间" :formatter="formatDate2" width="180">
                    </el-table-column>
                      <el-table-column prop="FProgress" label="进度"  width="100">
                    </el-table-column>
                      <el-table-column prop="FUseTime" label="耗时"  width="100">
                    </el-table-column>
                    <el-table-column prop="FNote" label="内容" width="100">
                    </el-table-column>
                </sy-baselist>
                </el-tab-pane>
            </el-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    import Duty from "../business/Duty.vue"
    import Duty1 from "../business/Duty1.vue"
    import editform from '../business/ProjectDetail_Edit.vue'
    export default {
         components:{
            Duty,editform,Duty1
        },
        mixins: [mixin],
      
        data(){
            return {
                returnTitle:"返回",
                activeTab:"tab_1",
                reportfilters:[],
                projectId:0,
                spanLeft:14,
               
            }
        },
        methods:{
            _initDetail(row){
                //组件嵌入
                 this.activeTab = "tab_1"
                 this.projectId = row.FID
                 this.$refs.duty._initProject(row.FID)
                 this.$refs.emp._initProject(row.FID,0)
                 this.$refs.jobPhoto._search("","FProjectId="+row.FID)
                 this.$refs.proreports._search("","FProjectId="+row.FID)
                 this.reportfilters= [
                    {type: "select",name:"FCreateUserId",text:"汇报人",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"},
                          {type: "date",name:"FCreateTime",text:"汇报时间"},
                   {type: "cascader",name:"FProjectDetailId",text:"项目阶段",value:"",remote:true,
                       data:"server/business/Project.ashx?cmd=GetDetailOptionsTree&FProjectId="+row.FID}, 
                ]
            },
            onSaveSuc:function (row) {
                this.$refs.jobPhoto._search("","FProjectId="+this.projectId)
            },
             beforeAddDetail(row,r){
                if(this.projectId==0) {
                    return r.error = "请先选择项目";
                }
                row.FJobID = this.projectId
            },
            formatIsTask(row){
                return row.FIsTask==1?'模板':'目录'
            },
           
            showbtn(row){
                if(row.FParentId!=0||row.FIsTask==1){
                    return false
                }
                return true
            },
             createEditForm(){
                let C = Vue.extend(require("@/pages/business/ProjectDetail_Edit.vue").default)
                let form = new C()
                form.$on("onSaveSuc", this.onSaveSuc)
                this.$el.appendChild(form.$mount().$el)
                if(this.reuseEditForm){
                  this.EditForm = form
               }else if(form.$children[0] && form.$children[0].$on){
                  //form子组件为el-dialog
                  //这里要销毁，以免使用相同窗体，状态保留出错
                  form.$children[0].$on("close",()=>{
                    form.$destroy(true);
                    this.$el.removeChild(form.$el);
                  })
                }
                return form
            },
             addchild(row){
                  row.FJobID = this.projectId
                  row.PID = row.FID
                  this.createEditForm()._openAdd(row)
            },
            changetab(val){
                if(val==1) this.$refs.jobPhoto._refrash()
                if(val==2) this.$refs.duty.$refs.list._refrash()
                if(val==3) this.$refs.proreports._refrash()
            },
            onPackUp(){
                 if (this.spanLeft == 14) {
                     this.spanLeft = 0
                    
                }else{
                   
                    this.spanLeft = 14
                }
            },
            currentChange(row){
                this.$refs.emp._initProject(row.FProjectId,row.FID,row.FParentId,row)
            }
        },
        created(){
           
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/ProjectDetail.vue